import { parentPort, workerData } from "node:worker_threads";
import type { JobTask } from "../types/job.js";
import type { WorkerBridgeRequest } from "./workerBridge.js";

const request = workerData as WorkerBridgeRequest;

async function run(): Promise<void> {
  const mod = (await import(request.modulePath)) as Record<string, unknown>;
  const worker = mod[request.exportName] as JobTask | undefined;
  if (typeof worker !== "function") {
    throw new Error(`Worker export "${request.exportName}" was not found or is not a function`);
  }
  const result = await worker({
    jobId: request.jobId,
    name: request.name,
    payload: request.payload,
    attempt: request.attempt,
    signal: new AbortController().signal,
    createdAt: new Date(request.createdAt),
    startedAt: new Date(request.startedAt),
    progress: async () => {},
  });
  parentPort?.postMessage({ ok: true, result });
}

run().catch((error: unknown) => {
  parentPort?.postMessage({
    ok: false,
    error: error instanceof Error ? { name: error.name, message: error.message, stack: error.stack } : error,
  });
});
